import { render, staticRenderFns } from "./Infomation.vue?vue&type=template&id=30d46ec6&scoped=true&"
import script from "./Infomation.vue?vue&type=script&lang=js&"
export * from "./Infomation.vue?vue&type=script&lang=js&"
import style0 from "./Infomation.vue?vue&type=style&index=0&id=30d46ec6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d46ec6",
  null
  
)

export default component.exports